import * as z from 'zod/mini';
import { submissionSchema } from '../../../../lib/comeet/submit/submissionSchema';

export const contactSchema = z.pick(submissionSchema, { name: true, email: true, location: true, linkedin: true });

export type ContactInfo = z.infer<typeof contactSchema>;
